var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4798 12.1429V8.07143C25.4798 6.99162 25.1315 5.95603 24.5116 5.19249C23.8915 4.42896 23.0507 4 22.1739 4H6.30582C5.42905 4 4.58819 4.42896 3.96822 5.19249C3.34825 5.95603 2.99995 6.99162 2.99995 8.07143V32.5C2.99995 33.5798 3.34825 34.6154 3.96822 35.3789C4.58819 36.1425 5.42905 36.5714 6.30582 36.5714H22.1739C23.0507 36.5714 23.8915 36.1425 24.5116 35.3789C25.1315 34.6154 25.4798 33.5798 25.4798 32.5V28.4286M30.7692 12.1429L37.3809 20.2857M37.3809 20.2857L30.7692 28.4286M37.3809 20.2857H14.8184",
    stroke: "#A6A6A6",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.16bfef92688014e079df9a7a6af0071d.svg";
export { ForwardRef as ReactComponent };